// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-3bca4329] {\n  flex: 0;\n}\n\n.link[data-v-3bca4329] {\n  align-items: center;\n  background-color: #7afbcd;\n  border: 1px solid #7afbcd;\n  border-radius: var(--magic-border-radius, 4px);\n  color: var(--magic-tertiary, #311261);\n  display: flex;\n  justify-content: center;\n  text-decoration: none;\n  height: 40px;\n  width: 40px;\n}\n.link.is-inactive[data-v-3bca4329] {\n  background-color: rgba(122, 251, 205, 0.7);\n}", ""]);
// Exports
module.exports = exports;
